import { test } from 'ramda'

const required = msj => value => !!value || msj || 'valor requerido'
const minSize = (min, msj) => value =>
  (!!value && value.length >= min) || msj || `tamaño mínimo requerido ${min}`
const noSpaces = msj => value =>
  (!!value && !test(/\s/, value)) || msj || 'espacios en blanco no permitidos'

export { required, minSize, noSpaces }
